module.exports = __webpack_public_path__ + "img/utk.7496b61d.svg";